import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { getCode } from '../../utils/utils'
import * as NavigationUtils from '../../utils/navigation';

import Home from './Home';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { usePatientDocumentContext } from '../../contexts/PatientDocument';

function HomeContainer() {
	const history = useHistory();
	const code = useMemo(() => getCode(), []);
	const { document } = usePatientDocumentContext();

	const [acceptedTerms, setAcceptedTerms] = useState(false);

	const navigateToSignaturePage = useCallback((status) => {
		const url = (status || document?.status) === 'SIGNED' ? `/signature-success?code=${code}` : `/document?code=${code}`

		NavigationUtils.navigate(history, url);
	}, [history, document?.status, code]);

	useEffect(() => {
		if (document?.signature_url) {
			history.push(`/signature-success?code=${code}`);
		}

		return;
	}, [document?.signature_url, code, history])

	const submit = useCallback(() => {
		const action = navigateToSignaturePage

		action();
	}, [ navigateToSignaturePage]);

    return (
		<Container>
			<Header/>

			<Home
				document={document}
				setAcceptedTerms={setAcceptedTerms}
				acceptedTerms={acceptedTerms}
				submit={submit}
			/>
		</Container>
	);
}

export default HomeContainer;
